import { primaryTheme } from 'radiance-ui/lib/constants';
import React from 'react';

import { ANTI_AGING, HAIR_LOSS, INGREDIENTS } from './ingredients-info';
import type { IngredientsProps } from '../Ingredients';

export const INGREDIENTS_PRODUCTS_CUSTOM_FORMULA_CONTENT: IngredientsProps = {
  header: (
    <React.Fragment>
      Proven ingredients, picked for <br />
      your goals
    </React.Fragment>
  ),
  ingredients: INGREDIENTS[ANTI_AGING],
  backgroundColor: primaryTheme.COLORS.white,
};

export const INGREDIENTS_PRODUCTS_CUSTOM_FORMULA_HAIR_CONTENT: IngredientsProps =
  {
    header: (
      <React.Fragment>
        Proven ingredients, picked for <br />
        your goals
      </React.Fragment>
    ),
    ingredients: INGREDIENTS[HAIR_LOSS],
    backgroundColor: primaryTheme.COLORS.white,
  };
